import { render } from "./MPSILeukocytes.vue?vue&type=template&id=0aa5a392&scoped=true"
import script from "./MPSILeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSILeukocytes.vue?vue&type=script&lang=js"

import "./MPSILeukocytes.vue?vue&type=style&index=0&id=0aa5a392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa5a392"]])

export default __exports__